import * as TypeGraphQL from "type-graphql";
export var AuthProvider;
(function (AuthProvider) {
    AuthProvider["CREDENTIALS"] = "CREDENTIALS";
    AuthProvider["GOOGLE"] = "GOOGLE";
    AuthProvider["GITHUB"] = "GITHUB";
})(AuthProvider || (AuthProvider = {}));
TypeGraphQL.registerEnumType(AuthProvider, {
    name: "AuthProvider",
    description: undefined,
});
//# sourceMappingURL=AuthProvider.js.map